module.exports = __webpack_public_path__ + "static/impressora-44a9215fa201091f4c28f0db6fbe8fc7.png";